export default __webpack_public_path__ + "static/Glitho-e2ec48f1d84146df5d84db67f2b8643f.jpg";